import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';

import { HomeScreenComponent } from './home-screen.component';
import { ResearchComponentModule } from '../../components/research-component.module';
import { ResearchScreenEffects } from '../../redux/effects/research-screen.effects';
import { WidgetsModule } from '../../widgets/widgets.module';
import { HomeScreenEffect } from '../../redux/effects/home-screen.effects';
import { TamDashboardModule } from '../../components/tam-dashboard/tam-dashboard.module';
import { EntityScreenEffect } from '../../redux/effects/entity-screen.effects';
import { WorkflowModule } from '../workflow/workflow.module';
import { TooltipModule } from '@progress/kendo-angular-tooltip';

@NgModule({
    imports: [
        // angular
        CommonModule,
        // ngrx
        EffectsModule.forFeature([
            ResearchScreenEffects,
            HomeScreenEffect,
            EntityScreenEffect
        ]),
        // project
        ResearchComponentModule,
        TamDashboardModule,
        TooltipModule,
        WidgetsModule,
        WorkflowModule
    ],
    declarations: [
        HomeScreenComponent,
    ],
})
export class HomeScreenModule { }
